import { Theme } from '@shipengine/giger-theme';
import { css, SerializedStyles } from '@emotion/react';

export const getContainerStyles = (theme: Theme): SerializedStyles =>
    css({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderRadius: theme.borderRadius.S,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3),
        minHeight: '100px',
        ...theme.getElevation('popout2'),
    });

export const getButtonStyles = (theme: Theme): SerializedStyles =>
    css({
        marginRight: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between',
    });

export const getTitleWrapperStyles = (theme: Theme): SerializedStyles =>
    css({
        display: 'flex',
        alignItems: 'self-end',
        marginBottom: theme.spacing(),
    });

export const getTitleStyles = (): SerializedStyles =>
    css({
        display: 'flex',
        alignItems: 'center',
    });

export const getEditIconStyles = (theme: Theme): SerializedStyles =>
    css({
        paddingRight: theme.spacing(),
    });

export const getSwitchStyles = (theme: Theme): SerializedStyles =>
    css({
        marginRight: theme.spacing(1 / 2),
    });

export const getTagStyles = (theme: Theme): SerializedStyles =>
    css({
        marginLeft: theme.spacing(2),
        fontSize: theme.typography.fontSize.XS,
    });

export const getDescriptionStyles = (): SerializedStyles =>
    css({
        maxWidth: '590px',
    });
